<template>
  <div class="privacy">
    <p align="center" style="text-align: center">
      <span style="font-size: 14pt">{{ app_name }}隐私权政策</span
      ><span style="font-size: 14pt"></span>
    </p>
    <p align="right" style="text-align: right">
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold">发布日期：</span
          ><span style="font-weight: bold">2021年5月19日</span></span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p align="right" style="text-align: right">
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold">生效日期：</span
          ><span style="font-weight: bold">2021年5月21日</span></span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p align="right" style="text-align: right">
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold">更新日期：</span
          ><span style="font-weight: bold">2022年5月30日</span></span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>

    <p>
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold">概</span> &nbsp;<span
            style="font-weight: bold"
            >述</span
          ></span
        ></b
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>{{ app_name }}（</span
        ><span
          >APP）是一款由{{
            company_name
          }}运营并提供按摩、保健生活服务的产品。</span
        ></span
      ><span style="font-size: 12pt"
        >我们深知个人信息对您而言的重要性，也感谢您对我们的信任。我们将通过本政策向您说明{{
          app_name
        }}会如何收集、存储、保护、使用及对外提供您的信息，并说明您享有的权利，其中要点如下：</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><u
          ><span style="font-weight: bold; font-size: 12pt"
            >1、为了便于您了解您在使用我们的服务时，我们需要收集的信息类型与用途，我们将结合具体服务向您逐一说明。</span
          ></u
        ></b
      ><b
        ><u><span style="font-size: 12pt"></span></u
      ></b>
    </p>
    <p>
      <b
        ><u
          ><span style="font-weight: bold; font-size: 12pt"
            >2、为了向您提供服务所需，我们会按照合法、正当、必要的原则收集您的信息。</span
          ></u
        ></b
      ><b
        ><u><span style="font-size: 12pt"></span></u
      ></b>
    </p>
    <p>
      <b
        ><u
          ><span style="font-weight: bold; font-size: 12pt"
            >3、原则上，为了保护您的个人信息，{{
              app_name
            }}不会将您的信息共享给任何第三方。如果为了向您提供服务而需要将您的信息共享至第三方，我们将评估该第三方收集信息的合法性、正当性、必要性。我们将要求第三方对您的信息采取保护措施并且严格遵守相关法律法规与监管要求。另外，我们会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗提示形式征得您的同意或确认第三方已经征得您的同意。</span
          ></u
        ></b
      ><b
        ><u><span style="font-size: 12pt"></span></u
      ></b>
    </p>
    <p>
      <b
        ><u
          ><span style="font-weight: bold; font-size: 12pt"
            >4、如果为了向您提供服务而需要从第三方获取您的信息，我们将要求第三方说明信息来源，并要求第三方保障其提供信息的合法性；如果我们开展业务需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权范围，我们将征得您的明确同意。</span
          ></u
        ></b
      ><b
        ><u><span style="font-size: 12pt"></span></u
      ></b>
    </p>
    <p>
      <b
        ><u
          ><span style="font-weight: bold; font-size: 12pt"
            >5、您可以通过本政策介绍的方式访问和管理您的信息、设置隐私功能、注销{{
              app_name
            }}账户或进行投诉举报。</span
          ></u
        ></b
      ><b
        ><u><span style="color: #0000ff; font-size: 12pt"></span></u
      ></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >本政策将帮助您了解以下内容：</span
        ></b
      ><b><span style="font-weight: bold; font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >一、我们如何收集和使用您的个人信息</span
        ></b
      ><b><span style="font-size: 10.5pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold">二、我们如何使用</span
          ><span style="font-weight: bold">Cookie、Beacon同类技术 </span></span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >三、我们如何共享、转让、公开披露您的个人信息</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >四、我们如何保存和保护您的个人信息</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >五、您如何管理您的个人信息</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >六、未成年人的个人信息保护</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >七、通知和修订</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >八、如何联系我们</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b><span style="font-weight: bold; font-size: 12pt">九、附录</span></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b><span style="font-size: 12pt">&nbsp;</span></b>
    </p>
    <p>
      <b
        ><u
          ><span style="font-size: 12pt"
            ><span style="font-weight: bold"
              >【特别提示】请您在使用我们提供的各项产品</span
            ><span style="font-weight: bold"
              >/服务前，仔细阅读并充分理解本《隐私政策》（重点内容我们已将字体加粗请您特别关注）并做出相应选择。一旦您使用或继续使用我们的产品/服务时，即意味着您同意我们按照本隐私政策处理您的相关信息。</span
            ></span
          ></u
        ></b
      ><b
        ><u><span style="font-size: 12pt"></span></u
      ></b>
    </p>
    <p>
      <b
        ><u
          ><span style="font-size: 12pt"
            ><span>如对本隐私政策有任何疑问，您可以通过本隐私政策</span
            ><span>“如何联系我们”中提供的方式与我们联系）。</span></span
          ></u
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>{{ app_name }}及关联公司（定义见附录）提供的产品</span
        ><span
          >/服务（包括未设独立隐私政策的{{
            app_name
          }}及关联公司提供的产品/服务），均适用本隐私政策，除非相关服务已有独立的隐私权政策或相应的用户服务协议当中存在特殊约定。</span
        ></span
      ><b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold">这些产品</span
          ><span style="font-weight: bold"
            >/服务包括{{ app_name }}网站(</span
          ></span
        ></b
      ><a href="http://www.angemo.com/"
        ><u
          ><span style="color: #0000ff; font-size: 12pt"
            ><span style="font-weight: bold">http://www.angemo.com/</span></span
          ></u
        ></a
      ><b
        ><span style="font-weight: bold; font-size: 12pt"
          >)、客户端以及相关微信开放平台账号或小程序。</span
        ></b
      ><span style="font-size: 12pt"
        ><span>此外，针对某些特定的产品</span
        ><span
          >/服务，我们可能还将制定单独的隐私政策，向您说明这些产品/服务的特殊政策。如相关特定的隐私政策与本隐私政策有不一致之处，适用该特定隐私政策。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">&nbsp;</span>
    </p>
    <p>
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold"
            >请您注意，本政策不适用于您通过我们的产品</span
          ><span style="font-weight: bold"
            >/服务而接入的其他第三方产品/服务（“其他第三方”，包括您的交易相对方、任何第三方网站以及第三方服务提供者），具体规定请参照该第三方的隐私政策或类似声明。</span
          ></span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b><span style="font-size: 12pt">&nbsp;</span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >一、我们如何收集和使用您的个人信息</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>在您使用我们的产品</span
        ><span
          >/服务时，您需要/可以选择授权我们收集和使用个人信息的场景包括：</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >1、为了向您提供我们产品/服务的基本功能，您需要授权我们收集、使用必要信息的情形，如您拒绝提供前述必要信息，您将无法正常使用我们的产品/服务；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >2、为了向您提供我们产品/服务的拓展功能，您可以选择授权我们收集、使用信息的情形，如您拒绝提供前述信息，您将无法正常使用相关附加功能或无法实现我们拟达到的功能效果，但并不会影响您正常使用我们产品/服务的基本功能。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">&nbsp;</span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >（一）您需要授权我们收集和使用个人信息的场景</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        >我们会遵循正当、合法、必要的原则，出于本政策所述的下列目的收集和使用您的个人信息。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >1、帮助您成为我们的用户</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt">为遵守法律法规的要求，以及向您提供更</span
      ><span style="font-size: 12pt">安全</span
      ><span style="font-size: 12pt"
        >的服务，在您注册成为{{
          app_name
        }}用户时，您需要至少提供手机号码以创建{{
          app_name
        }}账号，并完善相关的网络身份识别信息（头像、昵称及登录密码）；如果您仅需使用浏览、搜索功能，您无需注册成为我们的用户以及提供上述信息。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >在提供账号信息的过程中，如果您愿意额外补充如下个人信息，将有助于我们向您提供更为</span
        ></b
      ><b><span style="font-weight: bold; font-size: 12pt">优质</span></b
      ><b
        ><span style="font-weight: bold; font-size: 12pt"
          >的服务：包括您的微信账号、性别、年龄。如果您不提供该信息，不会影响您享受{{
            app_name
          }}服务的基本功能。</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >如您选择授权使用第三方账号登录时，我们会从第三方获取您共享的账号信息（头像、昵称、地区、性别信息）与您的{{
            app_name
          }}账号进行绑定用于快捷登录，我们会依据与第三方的约定，在符合相关法规的前提下，使用您的个人信息。</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>

    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >2、向您提供基于地理位置的信息展示</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        >为了向您提供周边按摩保健服务信息的展示和搜索服务，提升我们的服务表现、效率和功能，经您授权我们会收集您在使用我们服务过程中产生的相关信息，包括：</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold">（</span
          ><span style="font-weight: bold"
            >1）位置信息。当您通过系统授权开启移动设备的定位功能并使用基于位置提供的服务时，<b
              style="color: blue; font-weight: bold"
              >我们会收集和使用您的位置信息以便为您展示所在城市及周边的按摩保健服务</b
            ></span
          ></span
        ></b
      ><b><span style="font-weight: bold; font-size: 12pt"></span></b
      ><b><span style="font-weight: bold; font-size: 12pt"></span></b
      ><span style="font-size: 12pt"
        >（您不需要手动输入所在地理位置就可获得相关服务，估算商家与您之间的实际距离方便您进行消费决策，为您</span
      ><span style="font-size: 12pt">展示</span
      ><span style="font-size: 12pt"
        >附近的服务品类和优惠信息）。我们会使用有关技术获取您的</span
      ><b><span style="font-weight: bold; font-size: 12pt">位置信息</span></b
      ><span style="font-size: 12pt"
        ><span>（准确度会有所不同），这些技术包括</span
        ><span
          >IP地址、GPS以及能够提供相关信息的WLAN（Wi-Fi）接入点、蓝牙和基站。</span
        ></span
      ><b
        ><span style="font-weight: bold; font-size: 12pt"
          >您使用服务中提供的信息中可能包含相应地理位置信息，您在账号资料中设置的地区信息或您上传的图片、视频中的地理标记信息。您可以在移动设备的系统中关闭定位服务停止我们对您所在位置信息的收集，但可能因此无法使用我们基于地理位置为您提供的服务，或者无法达到相关服务的预期效果。</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          ><span>（</span><span>2）日志信息。</span></span
        ></b
      ><span style="font-size: 12pt"
        ><span>当您使用我们提供的产品</span
        ><span
          >/服务时，我们会收集您的浏览、搜索、点击、交易、售后、分享、发布信息并作为有关网络日志进行保存，其中包括您的IP地址、浏览器的类型、使用的语言、操作系统的版本、访问的日期和时间、电信运营商、网络请求。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >3、为您提供预订、下单、订单、售后管理功能</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>您在{{ app_name }}上预订</span
        ><span
          >/下单上门按摩保健、到店按摩保健服务时，您需要根据所选择的服务类型提供</span
        ></span
      ><b
        ><span style="font-weight: bold; font-size: 12pt; color: blue"
          >联系人信息（姓名、性别、电话号码）、地址信息、紧急联系人（包含紧急联系人真实姓名、关系、电话号码）。</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >4、为您提供服务评价的信息发布功能</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>您在{{ app_name }}上主动对商家的产品</span
        ><span
          >/服务进行评价时，我们将收集您发布的信息，并展示您的昵称、头像和发布内容。若您选择以匿名方式发布评价信息时，我们将不展示您的昵称、头像。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >5、为您提供客服和售后服务</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        >为完成身份核验，保障账号安全，确认交易状态及为您提供售后与争议解决目的，经您授权后我们可能会从第三方获取您的个人信息（通过您选择的交易对象和交易直接涉及的第三方信息系统、支付机构收集与交易进度相关的信息，以便于我们处理您的订单并保证服务的顺利完成，或者更好地预防诈骗、刷单恶意行为）。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >并且，当您与我们的客服取得联系时，我们的系统可能会记录您与客服之间的通讯记录、信息内容及通话录音，以及使用您的账号信息以便核验身份；当您需要我们提供与您订单相关的客户服务时，我们可能会查询您的相关订单信息以便给予您适当的帮助和处理；当您需要客服协助您修改有关信息（服务地址、联系方式）时，您可能还需要提供上述信息外的其他信息以便完成修改。为了保证服务体验、处理服务纠纷。有关上述信息的收集和使用规则如下，或参见订单页面中的提示内容。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>（</span
        ><span
          >1）经授权，当您与商家、技师间出现服务纠纷时，平台可调取并使用录音信息作为解决纠纷的参考依据。（2）平台将切实保障通话双方的隐私安全，录音将由{{
            app_name
          }}保存，各方无法自行下载、调取或播放录音；除以下情形外，平台不会将录音提供给任何人（包括通话主、被叫方）：a.有权机关依法定程序调取；b.被录音的一方持司法机关出具的法律文件依法调取。（3）录音在保存7天后将自动永久删除，如遇差评、投诉、尚未处理完毕的纠纷，平台将适当延长录音保存期限。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >前述信息属于您的<span style="font-weight: bold">个人敏感信息</span
          >，如您不提供前述信息，不影响您使用我们提供的其他服务。</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >6、对违规服务的举报、投诉功能</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>为了防止虚假投诉、商家</span
        ><span
          >/技师间的不正当竞争行为，在您针对{{
            app_name
          }}内相关商家、技师进行投诉、举报时，要求您提供身份信息（包括但不限于您的<b
            style="color: blue; font-weight: bold"
            >身份证、军官证、护照、驾驶证、学生证载明您身份的证件照片、复印件、号码</b
          >）进行实名投诉、举报，并提供相关投诉举报凭证（包括但不限于订单信息及商家、技师违规操作的视频录像、照片），以便于平台对您的投诉、举报内容进行核实。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b><span style="font-weight: bold; font-size: 12pt">7、支付功能</span></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        >在您下单后，您可通过{{
          app_name
        }}支持的第三方支付机构完成支付，支付功能本身并不收集您的个人信息，但我们需将您的订单号、交易金额以及其他您选择的支付机构要求的交易信息与您选择的支付机构共享以实现其确认您的支付指令并完成支付。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >8、平台入驻功能</span
        ></b
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >为保障交易安全以及根据法律法规的要求，入驻{{
          app_name
        }}的商家以及商家的员工在平台内的展示上线，均须进行实名认证</span
      ><span style="font-size: 12pt">及</span
      ><span style="font-size: 12pt">资质</span
      ><span style="font-size: 12pt">审核</span
      ><span style="font-size: 12pt"
        >。在实名认证的过程中，我们需要您提供<b
          style="color: blue; font-weight: bold"
          >真实姓名、身份证号码及面部特征值信息。</b
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p style="font-size: 12pt">
      需要您提供<b style="color: blue; font-weight: bold"
        >真实姓名、身份证号码及面部特征值信息。</b
      >。
      根据《中华人民共和国电子商务法》法律规定的平台入驻资质审核、备案要求，同时为了保障消费者交易安全，需要您在入驻{{
        app_name
      }}开展经营活动时提供必要的资质信息以供审核及备案，这些信息包括：a、商户头像：上传商户头像，以便对外展示及用户辨认；b、商户名称：设置商户名称；c、经营方式：选择并确定经营服务方式；d、店铺图片：上传至少一张店铺相关图片，须保证真实、原创、内容合法，不得侵犯任何第三方的合法权益；e、商户电话：以保证用户能及时联系您确定订单信息及售后服务，同时也属于平台与您联系（包含通过短信发送合作事宜的通知、违规警示、处罚结果告知）的方式之一；f、营业时间：确定营业时间有助于用户在合适的时间内找到您；g、店铺所在地区及详细地址：服务地址确定及平台内经营者的资质审核需要；h、位置确认：提供地理位置，以便于消费者能直接在平台内打开地图确定您的经营地址；i、人均消费：有助于消费者选择符合其消费水平的服务；j、房间数量及技师数量：有助于平台根据经营规模辅助判断您的经营及资质状况。
      ②个人入驻
      以个人（即自然人）身份入驻您应提供并授权我们收集以下信息：a、职业类型；b、选择并填写个性标签；c、上传语音签名；d、选择交友目的；e、填写个人介绍；f、填写昵称；g、选择性别；h、填写您的年龄；i、<span
        style="font-weight: bold"
        >真人认证：为了提升用户的消费体验，并保证服务真实，您应上传头像并至少提供3张或以上的本人照片进行真人认证</span
      >；j、所在城市。
      同时为了帮助您入驻并提升展示效果，您还可以选择提供以下额外信息，若您提供的，不影响提交您的入驻审核：a、<span
        style="font-weight: bold"
        >视频认证：选择提供一段关于个人介绍的认证视频</span
      >；b、填写微信号；c、设置查看微信号单价；d、选择是否公开展示，若不选择的默认为非公开展示。
      上述信息均为您自愿通过填写列表及主动上传的方式进行收集，未经您的同意，平台不会采用任何方式获取。其中部分信息属于<span
        style="font-weight: bold"
        >个人敏感信息</span
      >，您可以拒绝提供，但不得在{{
        app_name
      }}开展任何经营活动。这些信息仅供实名认证
      <span style="font-size: 12pt">、</span
      ><span style="font-size: 12pt"
        >平台对外经营信息公示的需要（为了给消费者提供更加优质的服务需要对外公示技师的<b
          style="color: blue; font-weight: bold"
          >性别、头像、年龄</b
        >）</span
      ><span style="font-size: 12pt"
        >及法律法规所规定的用途，未经您明示授权，不会用作其他目的。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >9、为您提供安全保障</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span
          >为了保障您的账号安全、交易安全以及系统运行安全，满足法律法规和我们协议规则的相关要求，在您使用我们的产品</span
        ><span>/服务过程中，经您授权我们会获取您的设备信息，</span></span
      ><b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold"
            >包括您使用的设备品牌、设备型号、设备名称、</span
          ><span style="font-weight: bold"
            >IP地址、SIM序列号、MAC地址、软件安装列表、设备软件版本信息、设备识别码、设备标识符、ANDROID
            ID、BSSID、所在地区、网络使用习惯、设备相关应用信息以及其他与{{
              app_name
            }}服务相关的日志信息。</span
          ></span
        ></b
      ><span style="font-size: 12pt"
        >前述信息当中包含您的<span style="font-weight: bold">个人敏感信息</span
        >，如您不同意我们记录前述信息，可能无法完成风控验证。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">&nbsp;</span>
    </p>
    <p>
      <span style="font-weight: bold; font-size: 12pt">（二）</span
      ><b
        ><span style="font-weight: bold; font-size: 12pt"
          >您可以选择授权我们收集和使用个人信息的场景</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt">为向您提供</span
      ><span style="font-size: 12pt">优质</span
      ><span style="font-size: 12pt"
        >的服务，您可以选择使用我们提供的拓展功能，我们会在符合法律规定并根据您具体授权的情况下收集并使用如下信息。这类信息将在您选择的具体功能和业务场景中进行收集，如果您不提供这些信息，不会影响您使用{{
          app_name
        }}的基本功能。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >1、基于相册授权的拓展功能</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >您可以选择开启系统的相册权限，通过主动上传图片、视频方式授权我们访问您的相册，以便于您通过上传照片或上传视频方式发布内容。</span
        ></b
      ><span style="font-size: 12pt"
        >我们会收集您选择上传发布的上述信息，此项功能您可以在系统权限中关闭，一旦关闭您将可能无法通过上传图片、视频方式进行更换头像、发布带图点评，</span
      ><b
        ><span style="font-weight: bold; font-size: 12pt"
          >但不会影响您享受{{ app_name }}服务的基本功能。</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >2、基于相机授权的拓展功能</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >您可以选择开启系统的相机权限，通过使用拍照、录视频，扫码功能授权{{
            app_name
          }}访问您的相机，以便于您通过拍摄照片或录制视频方式发布内容</span
        ></b
      ><span style="font-size: 12pt"
        >，如果您需要录制并发布有声视频时，您还需开启麦克风权限。我们会收集您上传发布的上述信息，此项功能您可以在系统权限中关闭，一旦关闭您将可能无法实现扫码功能，或者无法通过拍摄图片、视频方式进行发布介绍视频或语音进行推广，</span
      ><b
        ><span style="font-weight: bold; font-size: 12pt"
          >但不会影响您享受{{ app_name }}服务的基本功能。</span
        ></b
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >3、基于麦克风授权的拓展功能</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        >为更好地使用{{ app_name }}服务，您可能会启用麦克风与我们、{{
          app_name
        }}商家或其他主体沟通，我们可能会收集您的语音信息以识别您的需求，以及对于平台内的特定主体有权上传语音介绍。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >4、基于日历授权的拓展功能</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >您可以开启系统的日历权限，使用添加日历功能记录{{
            app_name
          }}相关服务的日程，我们会收集上述信息用于向您展示或定时提醒。</span
        ></b
      ><span style="font-size: 12pt"
        >此项功能您可以在系统权限中关闭，一旦关闭您将可能无法享受日历记录或提醒功能，</span
      ><b
        ><span style="font-weight: bold; font-size: 12pt"
          >但不会影响您享受{{ app_name }}服务的基本功能。</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt">5</span
      ><span style="font-size: 12pt"
        >、您理解并同意，在上述情形下，我们可能需要您在您的设备中开启您的摄像头（相机）、相册（图片库）、麦克风（语音）以及日历访问权限，以实现这些权限所涉及信息的收集和使用。您可在您的设备中逐项查看上述权限的状态，并可自行决定这些权限的开启或关闭。当您开启任一权限即代表您授权我们收集和使用该项信息来实现对应目标。您一旦关闭任一权限即代表您取消了授权，我们将不再继续收集和使用该项个人信息，也无法为您实现该授权所对应目标。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息的收集、处理与使用。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">&nbsp;</span>
    </p>
    <p>
      <b><span style="font-weight: bold; font-size: 12pt">（三）其他</span></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span
          >请您理解，我们向您提供的服务是不断更新和发展的。如您选择使用了前述说明当中尚未涵盖的其他服务，基于该服务我们需要收集您的信息的，我们会通过页面提示、交互流程、协议约定的方式另行向您说明信息收集的范围与目的，并征得您的同意。我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息；如您选择不提供前述信息，您可能无法使用某项或某部分服务，但不影响您使用我们提供的其他服务。此外，第三方主体可能会通过{{
            app_name
          }}</span
        ><span
          >APP向您提供服务。当您进入第三方主体运营的服务页面时，请注意相关服务由第三方主体向您提供。涉及到第三方主体向您收集个人信息的，建议您仔细查看第三方主体的隐私政策或协议约定。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">&nbsp;</span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >（四）征得同意的例外</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >请您知悉，以下情形中，我们收集、使用个人信息无需征得您的授权同意：</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt">1、与国家安全、国防安全直接相关的；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >2、与公共安全、公共卫生、重大公共利益有关的；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >3、与犯罪侦查、起诉、审判和判决执行有关的；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >4、出于维护个人信息主体或其他个人的生命、财产重大合法权益但又很难得到本人同意的；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">1、</span
      ><span style="font-size: 12pt"
        >所收集的个人信息是个人信息主体自行向社会公众公开的；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >6、从合法公开披露的信息中收集的您的个人信息的，合法的新闻报道、政府信息公开渠道；但是您明确拒绝或者处理该信息侵害您重大利益的除外。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">7、根据您的要求签订合同所必需的</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >8、用于维护所提供的产品与/或服务的安全稳定运行所必需的，发现、处置产品与/或服务的故障；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">9、为合法的新闻报道所必需的；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">11、法律法规规定的其他情形。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >请注意，单独或与其他信息相结合无法识别您的身份或者与您直接建立联系的信息，不属于个人信息。如果我们将单独无法与任何特定个人建立联系的信息与其他信息结合用于识别自然人个人身份，或者将其与个人信息结合使用，则在结合使用期间，此类信息将被视为个人信息。</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt">&nbsp;</span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          ><span>（五）个人信息的使用规则</span>
        </span></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt">为</span
      ><span style="font-size: 12pt">了</span
      ><span style="font-size: 12pt"
        >维护、改进我们的产品或服务质量，我们会在符合法律规定并根据您具体授权的情况下使用如下信息：</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">1</span
      ><span style="font-size: 12pt"
        ><span>、我们可能会收集您在参与产品</span
        ><span
          >/服务调查时主动向我们提供的信息，以及您与我们的关联方、合作伙伴之间互动时提供的相关信息，以便于您追踪订单情况、发起用户投诉以及我们优化客户服务的质量与流程。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">2</span
      ><span style="font-size: 12pt"
        >、我们可能将业务中收集的个人信息用于统计分析和改进运营，将已经去标识化无法识别您身份且不能复原的信息用于建立数据库并进行商业化利用。通过您所在的位置进行统计分析，从而改进我们</span
      ><span style="font-size: 12pt">的</span
      ><span style="font-size: 12pt"
        >系统而进行的技术改造、网络维护、故障排除、内部政策与流程制定、生成内部报告。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">3</span
      ><span style="font-size: 12pt"
        >、提高您使用{{ app_name }}及{{
          app_name
        }}关联公司、合作伙伴提供服务的安全性，确保操作环境安全与识别您的账号异常状态，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防网络漏洞、计算机病毒、网络攻击安全风险，我们可能自行或通过第三方机构使用或整合您的交易信息、设备信息、有关网络日志以及我们关联公司、合作伙伴取得您授权或依法律法规共享的信息，综合判断您的账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">&nbsp;</span>
    </p>
    <p>
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold">（六）设备权限调用</span>
        </span></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span
          >为确保相关业务功能的正常实现，我们需要根据具体的使用场景调用对应的必要权限，并在调用前向您弹窗询问，具体的权限调用说明请见下表：</span
        > </span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>{{ app_name }}权限列表</span> </span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">1、</span
      ><span style="font-size: 12pt">IOS系统权限调用说明</span
      ><span style="font-size: 12pt"></span>
    </p>
    <div class="data">
      <table>
        <thead>
          <tr>
            <td>设备权限</td>
            <td>使用目的</td>
            <td>是否询问</td>
            <td>是否可关闭</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>位置</td>
            <td>
              用于向用户展示所在城市及周边可为您提供按摩保健服务的商家和技师。
            </td>
            <td>首次打开客户端时询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>IDFA（IOS14及以上）</td>
            <td>用于保障用户的账号、交易安全</td>
            <td>首次打开客户端时弹窗询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>相机</td>
            <td>用于扫码、拍照、上传照片</td>
            <td>用户主动拍照、扫码、上传图片时询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>麦克风</td>
            <td>用于识别您的需求，以及对于特定主体上传语音介绍</td>
            <td>用户主动录音时询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>照片</td>
            <td>用于写入和读取用户相册信息</td>
            <td>用户主动上传前询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>日历</td>
            <td>用于向用户提供预定日程记录和提醒服务</td>
            <td>用户将行程添加至日历提醒前询问</td>
            <td>是</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>
      <span style="font-size: 12pt">2、</span
      ><span style="font-size: 12pt">Android系统权限调用说明</span
      ><span style="font-size: 12pt"></span>
    </p>
    <div class="data">
      <table>
        <thead>
          <tr>
            <td>设备权限</td>
            <td>使用目的</td>
            <td>是否询问</td>
            <td>是否可关闭</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>位置</td>
            <td>
              用于向用户展示所在城市及周边可为您提供按摩保健服务的商家和技师。
            </td>
            <td>首次打开客户端时询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>设备信息</td>
            <td>获取设备信息用于保障用户的账号、交易安全</td>
            <td>首次打开客户端时弹窗询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>相机</td>
            <td>用于扫码、拍照、上传照片</td>
            <td>用户主动拍照、扫码、上传图片时询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>麦克风</td>
            <td>用于识别您的需求，以及对于特定主体上传语音介绍</td>
            <td>用户主动录音时询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>照片</td>
            <td>用于写入和读取用户相册信息</td>
            <td>用户主动上传前询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>日历</td>
            <td>用于向用户提供预定日程记录和提醒服务</td>
            <td>用户将行程添加至日历提醒前询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>悬浮窗</td>
            <td>用于向用户提供访问客服入口</td>
            <td>用户可便捷访问客服消息</td>
            <td>是</td>
          </tr>
          <tr>
            <td>GET_TASKS获取应用列表</td>
            <td>提示用户应用处于后台</td>
            <td>不询问</td>
            <td>是</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>
      <span style="font-size: 12pt">3、</span
      ><span style="font-size: 12pt">HarmoyOS NEXT系统权限调用说明 </span
      ><span style="font-size: 12pt"></span>
    </p>
    <div class="data">
      <table>
        <thead>
          <tr>
            <td>设备权限</td>
            <td>使用目的</td>
            <td>是否询问</td>
            <td>是否可关闭</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>位置</td>
            <td>
              用于向用户展示所在城市及周边可为您提供按摩保健服务的商家和技师。
            </td>
            <td>首次打开客户端时询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>设备信息</td>
            <td>获取设备信息用于保障用户的账号、交易安全</td>
            <td>首次打开客户端时弹窗询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>相机</td>
            <td>用于扫码、拍照、上传照片</td>
            <td>用户主动拍照、扫码、上传图片时询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>麦克风</td>
            <td>用于识别您的需求，以及对于特定主体上传语音介绍</td>
            <td>用户主动录音时询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>照片</td>
            <td>用于写入和读取用户相册信息</td>
            <td>用户主动上传前询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>日历</td>
            <td>用于向用户提供预定日程记录和提醒服务</td>
            <td>用户将行程添加至日历提醒前询问</td>
            <td>是</td>
          </tr>
          <tr>
            <td>悬浮窗</td>
            <td>用于向用户提供访问客服入口</td>
            <td>用户可便捷访问客服消息</td>
            <td>是</td>
          </tr>
          <tr>
            <td>GET_TASKS获取应用列表</td>
            <td>提示用户应用处于后台</td>
            <td>不询问</td>
            <td>是</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>
      <span style="font-size: 12pt">&nbsp;</span>
    </p>
    <p>
      <span style="font-weight: bold; font-size: 12pt">二、</span
      ><b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold">我们如何使用</span
          ><span style="font-weight: bold">Cookie、Beacon同类技术 </span></span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b><span style="font-size: 12pt">&nbsp;</span></b>
    </p>
    <p>
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold">（一）</span
          ><span style="font-weight: bold">Cookie的使用</span></span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        >为确保网站正常高效运转、为您获得更轻松的访问体验</span
      ><span style="font-size: 12pt">，</span
      ><span style="font-size: 12pt"
        ><span>我们会在您的设备终端</span
        ><span
          >/系统上存储名为Cookie的小数据文件。Cookie会帮助您在后续访问我们网站时调用您的信息，简化您填写个人信息的流程；保护您的数据安全。我们不会将Cookie用于本隐私政策所述目的之外的任何用途。您</span
        ></span
      ><span style="font-size: 12pt">通过{{ app_name }}及设备系统</span
      ><span style="font-size: 12pt"
        ><span>管理或删除</span
        ><span
          >Cookie。您可以清除计算机或移动设备上保存的所有Cookie，您有权接受或拒绝
          Cookie。大多数浏览器会自动接受Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝Cookie；另外，您也可以清除软件内保存的所有Cookie。但您可能因此无法完全体验我们某些</span
        ></span
      ><span style="font-size: 12pt">优质</span
      ><span style="font-size: 12pt">和安全性的服务功能。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">&nbsp;</span>
    </p>
    <p>
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold">（二）网络</span
          ><span style="font-weight: bold">Beacon和同类技术的使用</span></span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>除</span
        ><span
          >Cookie外，我们网页上常会包含一些电子图像（称为"单像素"GIF文件或"网络Beacon"）其他同类技术，它们可以帮助网站计算浏览网页的用户或访问某些Cookie。我们使用网络Beacon的方式有：</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">1、</span
      ><span style="font-size: 12pt"
        ><span>我们通过在我们网站上使用网络</span
        ><span
          >Beacon，计算用户访问数量，并通过访问Cookie辨认注册用户。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">&nbsp;</span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >三、我们如何共享、转让、公开披露您的个人信息</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b><span style="font-weight: bold; font-size: 12pt">（一）共享</span></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        >我们不会与{{
          app_name
        }}以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">1、获得您明确同意或授权的共享。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >2、基于法定情形下：根据法律法规的规定、诉讼争议解决需要，或行政、司法有权机关依法提出的要求。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >3、与关联公司共享：为向您提供一致化服务以及便于您进行统一管理，我们可能会将您的个人信息与我们的关联公司共享。但我们只会共享必要的个人信息，如果我们共享您的<span
            style="font-weight: bold"
            >个人敏感信息</span
          >或者关联方改变个人信息的使用目的，将再次征求您的授权同意。</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >4、与合作伙伴分享：我们可能会向业务合作伙伴共享为您提供服务所必要的订单信息、账户信息、支付信息。</span
        ></b
      ><span style="font-size: 12pt">我们的业务合作伙伴包括以下类型：</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b><span style="font-weight: bold; font-size: 12pt">服务合作商。</span></b
      ><span style="font-size: 12pt"
        >仅为实现本政策中声明的目的，我们的某些服务将由业务合作伙伴提供。以保障为您提供的服务顺利完成，我们可能会将您的个人信息共享给上述合作伙伴，包括上门按摩业务、到店按摩业务。其中可能包括您的联络信息、订单信息、支付信息、地址信息，以保障为您提供的服务顺利完成。在您使用我们的服务时，我们必须与服务提供商共享您的订单和服务地址信息，以保证订单的安全准确进行；又如我们需要将您的订单号和订单金额与第三方支付机构共享以实现其确认您的支付指令并完成支付。</span
      ><b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold"
            >其中您的联络信息和地址信息属于<span style="font-weight: bold"
              >个人敏感信息</span
            >，我们已经采取了默认开启的</span
          ><span style="font-weight: bold"
            >“号码保护”单据上的“地址隐藏”举措尽全力保护您的个人信息。</span
          ></span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b><span style="font-weight: bold; font-size: 12pt">第三方商家。</span></b
      ><span style="font-size: 12pt"
        >我们必须将您的订单信息、必要交易信息与第三方商家共享，以便其向您提供商品、服务及售后。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >实现广告相关的信息共享</span
        ></b
      ><span style="font-size: 12pt"
        >为实现程序化广告推送，我们可能会与广告合作伙伴（包括广告主和其他广告服务提供商）共享去标识化或匿名化处理后的信息。未经您授权，我们不会将您的个人身份信息（即可以识别您<b
          style="font-weight: bold; color: blue"
          >身份的信息，姓名或手机号码</b
        >）与广告合作伙伴共享。
        只有在广告合作伙伴同意遵守我们的广告发布规范后，我们才会告诉广告合作伙伴其广告的效果如何，或者有多少人看了他们广告或在看到广告后安装了应用，或者向这些合作伙伴提供不能识别您个人身份的统计信息，帮助他们了解其受众群体。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <!-- 我们只会将匿名化的用户画像和经加密处理的设备信息与广告合作伙伴共享，以帮助其在不识别您个人身份的前提下提升广告的有效触达率。 -->
    <p>
      <span style="font-size: 12pt"
        >5、基于协议约定：依据您与我们签署的相关协议（包括在线签署的电子协议及平台规则）或法律文件，有必要向第三方共享时。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >6、基于合理商业习惯：与第三方共享联合营销活动中的中奖信息，以便第三方能及时向您发放奖品；或者在我们计划与其他公司进行资本市场活动（包括但不限于IPO，债券发行）接受尽职调查时。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >7、基于学术研究：为科研机构开展统计或学术研究之必要。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">8、基于符合法律法规的社会公共利益。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>我们会通过应用程序接口（</span
        ><span
          >API）、软件工具开发包（SDK）与第三方进行必要的数据共享，不同版本的第三方SDK会有所不同，一般包括第三方账号登录类、第三方支付类、地图导航类，我们会对第三方进行严格的安全检测并约定数据保护措施，以保障数据安全。</span
        ></span
      ><span style="font-size: 12pt">您可以</span
      ><span style="font-size: 12pt">选择</span
      ><span style="font-size: 12pt">通过</span
      ><span style="font-size: 12pt">以下</span
      ><span style="font-size: 12pt">SD</span
      ><span style="font-size: 12pt">K</span
      ><span style="font-size: 12pt">列表</span
      ><span style="font-size: 12pt">查</span
      ><span style="font-size: 12pt">看</span
      ><span style="font-size: 12pt">第三方的数据</span
      ><span style="font-size: 12pt">使用和保护规则</span
      ><span style="font-size: 12pt">：</span
      ><span style="font-size: 12pt"></span>
    </p>
    <!-- <iframe style="width:100wh" src="./joinSDKNotice"></iframe> -->
    <div class="data">
      <table>
        <thead>
          <tr>
            <td>SDK名称</td>
            <td>SDK用途</td>
            <td>共享个人信息字段</td>
            <td>服务方式</td>
            <td>所属机构</td>
            <td>官网链接</td>
          </tr>
        </thead>
        <tbody>
          <!-- <tr>
            <td>高德地图SDK</td>
            <td>提供配送地理位置信息服务</td>
            <td>
              读取
              IMEI作为设备标识、网络访问相关、设备MAC地址、唯一设备识别码、位置信息
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>高德软件有限公司</td>
            <td>https://lbs.amap.com/pages/privacy/</td>
          </tr> -->
          <tr>
            <td>腾讯Bugly闪退分析</td>
            <td>App闪退监控分析服务</td>
            <td>
              读取 IMEI作为设备标识、网络访问相关、设备MAC地址、唯一设备识别码
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf</td>
          </tr>
          <tr>
            <td>百度AI人脸对比</td>
            <td>提供人脸对比服务</td>
            <td>面容特征信息、照片信息</td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>北京百度网讯科技有限公司</td>
            <td>https://ai.baidu.com/ai-doc/REFERENCE/Akdyizf5t</td>
          </tr>
          <tr>
            <td>微信登录验证</td>
            <td>提供用户登录服务</td>
            <td>
              读取 IMEI作为设备标识、设备MAC地址、唯一设备识别码、位置信息
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>https://www.tencent.com/zh-cn/privacy-policy.html</td>
          </tr>
          <tr>
            <td>微信支付(com.tencent.mm.opensdk)</td>
            <td>提供用户支付服务</td>
            <td>
              读取IMEI作为设备标识、设备MAC地址、唯一设备识别码、位置信息、应用列表信息
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>
              https://pay.weixin.qq.com/index.php/public/apply_sign/protocol_v2
            </td>
          </tr>
          <tr>
            <td>图片选择器</td>
            <td>帮助用户选择并上传图片</td>
            <td>
              读取
              IMEI作为设备标识、设备MAC地址、唯一设备识别码、位置信息、网络访问相关
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>github.com</td>
            <td>https://github.com/LuckSiege/PictureSelector</td>
          </tr>
          <tr>
            <td>图像裁剪</td>
            <td>帮助用户对待上传的图片进行裁剪、压缩</td>
            <td>
              读取 IMEI作为设备标识、设备MAC地址、唯一设备识别码、位置信息
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>github.com</td>
            <td>https://github.com/Yalantis/uCrop</td>
          </tr>
          <tr>
            <td>
              阿里号码认证、阿里云一键登录（包含中国电信（cn.com.chinatelecom）、移动授权登录（com.cmic.sso））
            </td>
            <td>提供手机号码验证一键登录服务</td>
            <td>
              读取 IMEI作为设备标识、设备MAC地址、唯一设备识别码（Android
              ID、BSSID、SSID、OAID）、位置信息 、运营商信息、IP地址
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>阿里云计算有限公司、中国移动、中国电信、中国联通</td>
            <td>
              http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=a2c4g.11186623.J_9220772140.83.6ef47b76RfIXHR
            </td>
          </tr>
          <tr>
            <td>
              支付宝支付（包含支付宝安全（com.alipay.apmobilesecuritysdk））
            </td>
            <td>提供支付宝支付服务</td>
            <td>
              读取
              IMEI作为设备标识、设备MAC地址、唯一设备识别码、位置信息、IP地址、IMSI信息、当前已连接上的wifi的信息、OAID、AAID、SSID信息、BSSID信息、ICCID信息、AndroidID信息、传感器信息、运营商信息
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>支付宝（中国）网络技术有限公司</td>
            <td>https://docs.open.alipay.com/54</td>
          </tr>
          <tr>
            <td>极光统计</td>
            <td>统计分析</td>
            <td>
              读取
              IMEI作为设备标识、设备MAC地址、唯一设备识别码、位置信息、网络访问相关、
              应用列表信息
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>深圳市和讯华谷信息技术有限公司</td>
            <td>https://www.jiguang.cn/license/privacy</td>
          </tr>
          <tr>
            <td>极光推送</td>
            <td>统计推送服务</td>
            <td>
              读取
              IMEI作为设备标识、设备MAC地址、唯一设备识别码、位置信息、网络访问相关、
              网络信息(IP 地址、WiFi
              信息、基站信息、DNS地址、DHCP地址、SSID、BSSID)与位置信息（经纬度）
            </td>
            <td>
              嵌入该SDK，SDK将传输个人信息,用于优化SDK与极光服务器的网络连接请求，保证服务的稳定性和连续性，同时实现区域推送功能；
            </td>
            <td>深圳市和讯华谷信息技术有限公司</td>
            <td>https://www.jiguang.cn/license/privacy</td>
          </tr>
          <tr>
            <td>穿山甲广告推广（com.bytedance.sdk.openadsdk）</td>
            <td>提供广告投放、反作弊广告流量统计相关服务。</td>
            <td>
              读取
              设备MAC地址、设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、硬件序列号build_serial、软件列表信息、传感器、精确位置信息、粗略位置信息（WiFi列表、WLAN接入点（如SSID，BSSID）、基站。
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>北京巨量引擎网络技术有限公司</td>
            <td>https://www.pangle.cn/privacy</td>
          </tr>
          <tr>
            <td>字节跳动APPLOG、今日头条（com.bytedance）</td>
            <td>提供广告流量统计相关服务</td>
            <td>
              读取
              IMEI作为设备标识、ip地址、设备MAC地址、唯一设备识别码（Android
              ID、BSSID、SSID、OAID）、位置信息、网络访问相关，获取传感器信息、
              应用列表信息
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>北京巨量引擎网络技术有限公司</td>
            <td>https://www.pangle.cn/privacy</td>
          </tr>
          <tr>
            <td>
              友盟移动统计、友盟社会化分享（包含友盟组件化基础库（com.umeng.commonsdk、com.umeng.analytics、com.umeng））
            </td>
            <td>提供多平台分享、数据统计相关功能</td>
            <td>
              读取 IMEI作为设备标识、设备MAC地址、唯一设备识别码（Android
              ID、BSSID、SSID、OAID、GUID）、网络信息、位置信息、软件安装列表、获取设备序列号、获取ICCID。
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>友盟同欣（北京）科技有限公司、北京锐讯灵通科技有限公司</td>
            <td>
              https://www.umeng.com/page/policy?spm=a213m0.21983069.0.0.5a90ffa3xK6ILl
            </td>
          </tr>
          <tr>
            <td>腾讯即时通信IM</td>
            <td>提供客服聊天消息提醒</td>
            <td>
              读取 IMEI作为设备标识、设备MAC地址、唯一设备识别码、位置信息
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>腾讯云计算（北京）有限责任公司</td>
            <td>https://cloud.tencent.com/document/product/301/11470</td>
          </tr>
          <tr>
            <td>
              腾讯广点通、优量汇SDK（com.qq.e.comm.DownloadService、com.qq.e、com.qq.e.ads、com.tencent.turingfd）
            </td>
            <td>广告请求</td>
            <td>
              唯一设备识别码（SSID、BSSID、IMEI、Android_ID），获取传感器信息，外置存储信息（SD卡数据读写权限），运营商信息，应用列表信息，周围的WiFi信息
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>
              https://imgcache.qq.com/gdt/cdn/adn/uniondoc/ylh_sdk_privacy_statement.html
            </td>
          </tr>
          <tr>
            <td>站长统计分析WEB版</td>
            <td>WEB流量统计</td>
            <td>网络访问相关、 IP地址</td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>友盟同欣（北京）科技有限公司、北京锐讯灵通科技有限公司</td>
            <td>https://www.cnzz.com/o_index.php</td>
          </tr>
          <tr>
            <td>腾讯tbs浏览服务</td>
            <td>实现稳定的webview</td>
            <td>
              读取 IMEI作为设备标识、网络访问相关、设备MAC地址、唯一设备识别码
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>https://x5.tencent.com/tbs/policy.html</td>
          </tr>
          <tr>
            <td>阿里百川</td>
            <td>
              淘宝授权、唤醒手淘、使用淘宝第三方登录、用户可将某些功能/能力授权给媒体使用，媒体可通过获取用户的授权来访问页面/APi数据，使用淘宝登录会透传用户登录状态）
            </td>
            <td>
              读取
              IMEI作为设备标识、网络访问相关、设备MAC地址、唯一设备识别码、位置信息
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>浙江淘宝网络有限公司</td>
            <td>
              https://baichuan.taobao.com/docs/doc.htm?spm=a3c0d.7386797.0.0.51b1be48Nrdj7N&source=search&treeId=37&articleId=105002&docType=1
            </td>
          </tr>
          <tr>
            <td>腾讯地图</td>
            <td>为用户提供位置及地图导航功能</td>
            <td>
              开放匿名设备标识符、周围的WiFi信息、当前已连接上的wifi的信息、BSSID信息、SSID信息、蓝牙信息
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>https://lbs.qq.com/userAgreements/agreements/mapSDK</td>
          </tr>
          <tr>
            <td>百度统计SDK</td>
            <td>统计服务</td>
            <td>
              读取
              IMEI作为设备标识、设备MAC地址、唯一设备识别码、位置信息、网络访问相关
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>北京百度网讯科技有限公司</td>
            <td>https://www.baidu.com/duty/yinsiquan-policy.html</td>
          </tr>
          <tr>
            <td>腾讯图灵盾</td>
            <td>
              用于设备标识符本身的有效性校验，并甄别设备环境异常，以识别设备风险和虚假流量
            </td>
            <td>
              读取 IMEI作为设备标识、设备MAC地址、唯一设备识别码（Android
              ID、BSSID、SSID、OAID）、软件安装列表、获取设备序列号
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>
              https://privacy.qq.com/document/preview/5331f064a91a47eb93993fdacb91c8f7
            </td>
          </tr>
          <tr>
            <td>中国移动一键登录 、中国移动号码认证</td>
            <td>一键登录</td>
            <td>
              读取 IMEI作为设备标识、设备MAC地址、唯一设备识别码（Android
              ID、BSSID、SSID、OAID）、软件安装列表、获取设备序列号、位置信息
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>中移互联网有限公司</td>
            <td>https://wap.cmpassport.com/resources/html/contract.html</td>
          </tr>
          <tr>
            <td>中国联通一键登录 、中国联通号码认证</td>
            <td>一键登录</td>
            <td>
              读取 IMEI作为设备标识、设备MAC地址、唯一设备识别码（Android
              ID、BSSID、SSID、OAID）、软件安装列表、获取设备序列号、位置信息
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>中国联合网络通信有限公司</td>
            <td>
              https://opencloud.wostore.cn/authz/resource/html/disclaimer.html
            </td>
          </tr>
          <tr>
            <td>中国电信一键登录 、中国电信号码认证</td>
            <td>一键登录</td>
            <td>
              读取 IMEI作为设备标识、设备MAC地址、唯一设备识别码（Android
              ID、BSSID、SSID、OAID）、软件安装列表、获取设备序列号、位置信息
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>世纪龙信息网络有限责任公司</td>
            <td>
              https://e.189.cn/sdk/agreement/content.do?type=main&appKey=&hidetop=true&returnUrl=
            </td>
          </tr>
          <tr>
            <td>Chromium</td>
            <td>谷歌公司提供的AndroidX辅助开发工具，提供网页浏览服务</td>
            <td>
              获取SSID、WIF状态、网络额外信息、WIF名称、传感器信息、传感器列表、设备MAC地址、IP、剪切板、通话状态
            </td>
            <td>嵌入该SDK，SDK将传输个人信息</td>
            <td>Google LLC</td>
            <td>https://www.chromium.org/chromium-projects/</td>
          </tr>
          <tr>
            <td>com.blankj:utilcodex（安卓工具库）</td>
            <td>提高开发效率，优化产品模块</td>
            <td>
              获取设备标识符（Android如IMEI、AndroidID、Serial、IMSI、IDFA），MAC
              地址，IP地址，应用列表信息
            </td>
            <td></td>
            <td></td>
            <td>https://github.com/Blankj/AndroidUtilCode</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >请您知悉，我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，对我们仅为实现本政策中声明的目的与之共享个人信息的公司、组织和个人，我们会与其签署严格的信息保护和保密协定，要求他们遵守协议并采取相关的安全措施来保护您的个人信息。</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b><span style="font-weight: bold; font-size: 12pt">（二）转让</span></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        >随着我们业务的发展，我们及我们的关联方有可能进行合并、收购、资产转让或类似的交易，如涉及个人信息的转让，我们会要求受让您个人信息的公司、组织继续接受本隐私政策的约束，否则，我们将要求该公司、组织重新征求您的授权同意。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold">（三）公开披露</span>
        </span></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        >我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才可能公开披露您的个人信息：</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >1、根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >2、根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件传票或调查函。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >请注意，您在使用我们服务时自愿发布甚至公开分享的信息，可能会涉及您或他人的个人信息甚至<span
            style="font-weight: bold"
            >个人敏感信息</span
          >，如您的交易信息，以及您在评价时选择上传包含个人信息的文字、图片或视频各种形式的信息。请您在使用我们的服务时更加谨慎地考虑，是否要发布甚至公开分享相关信息。</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        >以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">1、与国家安全、国防安全有关的；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >2、与公共安全、公共卫生、重大公共利益有关的；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >3、与犯罪侦查、起诉、审判和判决执行有关的；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >4、出于维护您或其他个人的生命、财产重大合法权益但又很难得到本人同意的；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">5、其他维护公共利益的情形；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">6、您自行向社会公众公开的个人信息；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >7、从合法公开披露的信息中收集个人信息的，合法的新闻报道、政府信息公开渠道。但是您明确拒绝或者处理该信息侵害您重大利益的除外。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >根据法律规定，共享、转让、公开披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，我们对此类数据的处理将无需另行向您通知并征得您的同意。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >四、我们如何保存和保护您的个人信息</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold">（一）个人信息的保存</span>
        </span></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p style="font-weight: bold; font-size: 12pt">
      保存期限：除非依据法律法规或双方约定，我们仅会在实现目的所必需的最短时间内留存您的相关个人信息。在超出存储期限后，我们会依法删除或匿名化处理您的个人信息。如果删除从技术上难以实现的，我们会停止除存储和采取必要的安全保护措施之外的处理活动。在您主动注销账号时，我们将根据法律法规的要求尽快删除您的个人信息或匿名化处理，有关注销账号的相关规则和流程，请参见本政策附件中的《用户注销协议》。
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >2、保存地域：</span
        ></b
      ><span style="font-size: 12pt"
        >我们在中华人民共和国境内收集和产生的个人信息，将存储在中国境内，但以下情形除外：</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">法律法规有明确规定的；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">单独征得您的授权同意；</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >在上述情形中，我们会并要求数据接收方按照本隐私政策以及其他相关的安全保密措施来处理个人信息。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b><span style="font-weight: bold; font-size: 12pt">3、终止运营</span></b
      ><span style="font-size: 12pt"
        ><span>：如果发生终止运营情形，我们将会至少提前</span
        ><span
          >30天通知您，并在终止运营后对您的个人信息进行删除或匿名化处理。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >（二）个人信息的保护措施</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt">1、数据安全措施</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span
          >为保障您的信息安全，我们努力采取各种符合业界标准的物理、电子和管理方面的安全措施来保护您的个人信息，建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。{{
            app_name
          }}通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。防止您的个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。在您的浏览器与</span
        ><span
          >“服务”之间交换数据时采用SSL加密保护技术；同时对网站本身提供https安全浏览方式；使用加密技术确保数据的保密性；使用受信赖的保护机制防止数据遭到恶意攻击；部署访问控制机制，确保只有授权人员才可访问个人信息；以及举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">2、请您知悉并理解，</span
      ><b
        ><span style="font-weight: bold; font-size: 12pt"
          >互联网并非绝对安全的环境，我们强烈建议您通过安全方式、使用复杂密码，协助我们保证您的账号安全。如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄露，请您立即根据本隐私政策中提供的联系方式联络我们，以便我们采取相应措施。</span
        ></b
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">3、安全事件</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >在不幸发生个人信息安全事件后，我们会立即成立专项应急小组，启动应急预案，防止安全事件扩大，并按照法律法规的要求及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以邮件、信函、电话方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-weight: bold; font-size: 12pt">五、</span
      ><b
        ><span style="font-weight: bold; font-size: 12pt"
          >您如何管理您的个人信息</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt">您对您的个人信息享有以下权利：</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >（一）您有权访问、更正、删除您的个人信息，法律法规规定的例外情况除外。</span
        ></b
      ><span style="font-size: 12pt">您可以通过以下方式管理您的信息：</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b><span style="font-weight: bold; font-size: 12pt">账户信息</span></b
      ><span style="font-size: 12pt"
        >——您可以访问、更正您账户中的个人资料及账号信息（身份认证信息除外）、支付信息、账号绑定信息，也可以更改您的密码、添加安全信息或进行第三方账号的解绑，您可以通过访问网页及App在设置中执行此类操作。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b><span style="font-weight: bold; font-size: 12pt">地址信息</span></b
      ><span style="font-size: 12pt"
        >——您可以通过访问{{
          app_name
        }}网页/App页面上的“我的”—“我的地址”中随时添加、更改、删除您的服务地址信息（</span
      ><b
        ><span style="font-size: 12pt; color: blue; font-weight: bold"
          >包括联系人姓名、性别、服务地址、电话号码</span
        ></b
      ><span style="font-size: 12pt">）。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b><span style="font-weight: bold; font-size: 12pt">搜索浏览信息</span></b
      ><span style="font-size: 12pt"
        >——您可以在{{
          app_name
        }}网页/App中访问或清除您的搜索历史记录、查看</span
      ><span style="font-size: 12pt">及</span
      ><span style="font-size: 12pt">管理其他数据。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b><span style="font-weight: bold; font-size: 12pt">订单信息</span></b
      ><span style="font-size: 12pt"
        >——您可以通过访问“我的订单”页面查看您的所有已经完成、待付款、待售后、待评价的订单。您可以选择删除已完成的订单信息，但这样可能导致我们无法根据您的购买信息而准确提供相应的售后服务。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b><span style="font-weight: bold; font-size: 12pt">评论信息</span></b
      ><span style="font-size: 12pt"
        >——您可以通过访问{{
          app_name
        }}App页面上的“评价”访问、更正、清除您的评论内容。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span
          >如果您无法通过上述链接管理这些个人信息，您可以随时通过本隐私政策中提供的反馈方式联系我们。我们将在</span
        ><span>15天内回复您的访问请求。</span></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >（二）改变您授权同意的范围或撤回授权</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>您可以通过在{{ app_name }}</span
        ><span
          >App中删除信息、更改隐私设置或者在系统中关闭设备权限功能方式改变同意范围或撤回您的授权。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >请您理解，当您执行上述操作后，我们将无法继续为您提供撤回同意或授权所对应的服务，但不会影响此前基于您的授权已经开展的个人信息处理。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >（三）获取您的个人信息副本</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p style="font-size: 12pt">
      您有权获取您的个人信息副本。如您需要获取我们收集的您的个人信息副本，您可通过拨打人工客服热线4008620602、在线客服，人工客服会对您进行个人信息校验，完成<b
        style="font-weight: bold; color: blue"
        >姓名、电话、身份证</b
      >后六位的个人信息主体确认后，将个人信息副本通过本App在线客服提交给您。在符合相关法律规定且技术可行的前提下，我们将根据您的要求向您提供您的个人信息副本。
      在技术可行的前提下，如数据接口已匹配，我们还可按您的要求，直接将您的个人信息副本传输给您指定的第三方。
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >（四）注销账户</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        >您可以通过联系{{ app_name }}客服要求注销您的{{ app_name }}账户，</span
      ><b
        ><span style="font-weight: bold; font-size: 12pt"
          >有关注销账户的相关规则和流程，请参见附件中的《用户注销协议》。您注销成功后，我们将根据法律法规的要求尽快删除您的个人信息或做匿名化处理。</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span
          >如果您无法通过上述方式访问、更正或删除您的个人信息以及注销账号，或者如果您认为{{
            app_name
          }}存在违反法律的规定收集、使用您个人信息的情形，您可以通过我们的客服或通过本隐私政策提供的其他方式与我们取得联系。为了保障安全，我们可能需要您提供相应方式证明您的身份和请求的正当性，我们将在收到您反馈并验证您的身份后的</span
        >
        <span
          >15
          天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold">六、未成年人的个人信息保护</span>
        </span></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p style="color: blue; font-weight: bold">
      <span style="font-size: 12pt"
        >1、{{
          app_name
        }}非常重视对未成年人个人信息的保护。我们的网站和服务主要面向成人。</span
      ><b
        ><span style="font-weight: bold; font-size: 12pt"
          >如您为未成年人的，建议您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。</span
        ></b
      ><span style="font-size: 12pt"
        >对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >2、如您为未成年人的父母或监护人，当您对您所监护的未成年人的信息处理存在疑问时，请通过下文中的联系方式联系我们。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold">七、通知和修订</span>
        </span></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        >为给您提供更好的服务，我们的业务将不时变化，本隐私政策也将随之调整。未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在我们网站、移动端上发出更新版本或以其他方式提醒您相关内容的更新，也请您访问我们以便及时了解最新的隐私政策。在前述情况下，若您继续使用我们的服务，即表示同意接受修订后的本政策并受之约束。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >发生下列重大变化情形时，我们会适时对本政策进行更新：</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>（</span
        ><span
          >1）我们的基本情况发生变化，兼并、收购、重组引起的所有者变更；</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>（</span
        ><span
          >2）收集、存储、使用个人信息的范围、目的、规则发生变化；</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>（</span
        ><span>3）对外提供个人信息的对象、范围、目的发生变化；</span></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>（</span
        ><span>4）您访问和管理个人信息的方式发生变化；</span></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>（</span
        ><span>5）数据安全能力、信息安全风险发生变化；</span></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>（</span
        ><span
          >6）用户询问、投诉的渠道和机制，以及外部纠纷解决机构及联络方式发生变化；</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>（</span
        ><span>7）其他可能对您的个人信息权益产生重大影响的变化。</span></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >八、如何联系我们</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>您可以通过以下方式与我们联系，我们将在</span>
        <span>15 天内答复您的请求；</span></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">1、您可以通过{{ app_name }}网站（</span
      ><a href="http://www.angemo.com/"
        ><u
          ><span style="color: #0000ff; font-size: 12pt"
            ><span>http://www.angemo.com/</span></span
          ></u
        ></a
      ><span style="font-size: 12pt"
        ><span>）</span
        ><span>/App上提供的在线联系方式/客服系统与我们联系；</span></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >2、您可以联系{{
          app_name
        }}的客服电话进行反馈（联系方式：400-862-0602）。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >3、我们还设立了专门的个人信息保护团队，如果您有任何个人信息的疑问、意见、建议或投诉举报，您可以通过 </span
      ><a href="mailto:wzh@angemo.com"
        ><u
          ><span style="color: #0000ff; font-size: 12pt"
            ><span>wzh@angemo.com</span></span
          ></u
        ></a
      ><span style="font-size: 12pt"
        >&nbsp;<span>联系我们，或者寄信到如下地址：</span></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>深圳市罗湖区东晓街道绿景社区布吉路</span
        ><span
          >1028号中设广场B楼3层306A
          法务部隐私保护中心（收），邮编：518000。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >附录（本政策中关键词说明）：</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt; color: blue"
          >1、个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中可能涉及的个人信息包括但不限于：个人基本信息（包括姓名、电话号码、性别、住址、生日）；个人身份信息（包括身份证、军官证、护照、驾驶证）；网络身份标识信息（包括系统账号、IP
          地址、邮箱地址及与前述有关的密码、口令、口令保护答案）；个人财产信息（包括银行账号、交易和消费记录、信贷记录以及虚拟财产信息）；个人健康生理信息（包括病症、病历、病史）；联系人信息（包括通讯录信息、好友列表）；个人上网记录（包括网站浏览记录、点击记录）；个人设备信息（包括唯一设备识别码描述个人常用设备基本情况的信息）；个人位置信息（包括行踪轨迹、精准定位信息、住宿信息）。</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >2、<span style="font-weight: bold">个人敏感信息</span
          >：是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇的个人信息。本隐私政策中可能涉及的个人敏感信息包括：个人身份认证信息（包括<b
            style="font-weight: bold; color: blue"
            >身份证、军官证、护照、驾驶证、学生证</b
          >）；个人财产信息（<b style="font-weight: bold; color: blue"
            >银行账号、交易和消费记录、信贷记录以及虚拟财产信息</b
          >）；其他信息（<b style="font-weight: bold; color: blue"
            >行踪轨迹、通讯录信息、住宿信息、精准定位信息</b
          >）；14 周岁以下的儿童信息。</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >3、{{ app_name }}：</span
        ></b
      ><span style="font-size: 12pt"
        ><span>本政策中所指的</span
        ><span
          >“{{ app_name }}”是指{{
            app_name
          }}旗下所有公司及其附属、关联公司。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >4、关联公司：</span
        ></b
      ><span style="font-size: 12pt">深圳凹凹网络科技有限公司。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >5、关联账号：</span
        ></b
      ><span style="font-size: 12pt"
        ><span>您可以使用相同的手机号码登录{{ app_name }}所提供的产品</span
        ><span
          >/服务，并授权使用您的{{
            app_name
          }}账号信息（头像、昵称、收货地址），以便于我们基于关联账号向您提供一致的服务以及您进行统一管理。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >6、设备信息：</span
        ></b
      ><span style="font-size: 12pt"
        ><span>设备标识符（</span
        ><span
          >IMEI、IDFA、Android
          ID、MAC、OAID相关信息）、应用信息（应用崩溃信息、通知开关状态、软件列表相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >7、去标识化：</span
        ></b
      ><span style="font-size: 12pt"
        >指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b><span style="font-weight: bold; font-size: 12pt">8、匿名化：</span></b
      ><span style="font-size: 12pt"
        >指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt">&nbsp;</span>
    </p>
    <p>
      <b><span style="font-weight: bold; font-size: 12pt">附件一：</span></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >《用户注销协议》</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        >在您注销您的账户之前，请充分阅读、理解并同意下列事项：</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span
          >在此善意地提醒您，您注销{{
            app_name
          }}账户的行为，将导致我们终止对您提供本服务，也会给您的售后维权带来诸多不便。注销成功后，我们将删除您的个人信息，使其保持不可被检索、访问的状态，或对其进行匿名化处理。您知晓并理解，根据相关法律规定相关交易记录须在{{
            app_name
          }}保存</span
        >
        <span>3 年甚至更长的时间。</span></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >1、如果您仍执意注销账户，您的账户需同时满足以下条件：
        </span></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold"
            >（1）账户在{{ app_name }}系统中无资产、无欠款；</span
          ></span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold"
            >（2）账户内无未完成的订单、已提供服务但未支付的订单/服务；</span
          ></span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold"
            >（3）账户无任何纠纷，包括投诉举报或被投诉举报；</span
          ></span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <b
        ><span style="font-size: 12pt"
          ><span style="font-weight: bold"
            >（4）账户为正常使用中的账户且无任何账户被限制的记录。</span
          ></span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        >2、在{{ app_name }}账户注销期间，如果您的{{
          app_name
        }}账户涉及争议纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查，{{
          app_name
        }}有权自行终止本{{ app_name }}账户的注销而无需另行得到您的同意。 </span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        >3、请您在提交注销申请前，务必解绑其他相关账户，具体可与我们的客服联系。</span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >4、{{
            app_name
          }}账户一旦被注销将不可恢复，请您在操作之前自行备份账户相关的所有信息和数据。注销{{
            app_name
          }}账户，您将无法再使用本{{ app_name }}账户，也将无法找回您{{
            app_name
          }}账户中及与账户相关的任何内容或信息（即使您使用相同的手机号码再次注册并使用{{
            app_name
          }}），包括但不限于：</span
        ></b
      ><b><span style="font-size: 12pt"></span></b>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>（</span
        ><span>1）您将无法登录、使用{{ app_name }}账户；</span></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>（</span
        ><span
          >2）{{
            app_name
          }}账户的个人资料和历史信息（包括但不限于用户名、昵称、头像、预订/团购记录）都将无法找回；</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <span style="font-size: 12pt"
        ><span>（</span
        ><span
          >3）您通过{{ app_name }}账号进行登录的{{
            app_name
          }}旗下各网站/APP所有记录将无法找回。您将无法再登录、使用前述服务，您曾获得的优惠券、积分、及其他卡券视为您自行放弃，将无法继续使用。您理解并同意，{{
            app_name
          }}无法协助您重新恢复前述服务。</span
        ></span
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >5、注销本{{ app_name }}账户并不代表本{{
            app_name
          }}账户注销前的账户行为和相关责任得到豁免或减轻。</span
        ></b
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >6、您可以通过“我的→设置→关于我们→隐私政策→撤回”来改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</span
        ></b
      ><span style="font-size: 12pt"></span>
    </p>
    <p>
      <b
        ><span style="font-weight: bold; font-size: 12pt"
          >7、您可以通过客服电话4008620602或通过“我的→设置→账户与安全→注销账户”，解除实名绑卡授权。</span
        ></b
      ><span style="font-size: 12pt"></span>
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: 1,
      app_name: "按个摩",
      company_name: "深圳凸凸网络科技有限公司",
    };
  },
  mounted() {
    console.log(this.$route);
    this.type = this.$route.params.type || 1;

    if (this.$route.query.type == 4) {
      this.app_name = "按个摩上门按摩";
    }
    if (this.$route.query.type == 5) {
      this.app_name = "按个摩极速版";
    }
    if (this.$route.query.type == 6) {
      this.app_name = "按一按";
      this.company_name = "深圳凹凸信息技术有限公司";
    }
    if (this.$route.query.type == 7) {
      this.app_name = "按一按上门按摩";
      this.company_name = "深圳凸凸网络科技有限公司";
    }
    if (this.$route.query.type == 8) {
      this.app_name = "按一按上门按摩";
      this.company_name = "深圳凹凸信息技术有限公司";
    } 
    if (this.$route.query.type == 9) {
      this.app_name = "按个摩接单";
      this.company_name = "深圳凹凸信息技术有限公司";
    }
  },
};
</script>
<style lang="scss" scoped>
@import url("../assets/style/rem.css");

.privacy {
  padding: 0.2rem;

  table,
  td,
  tr {
    border: none;
  }

  iframe {
    width: 100%;
    border: none;
    height: 2600px;
  }

  .data {
    width: 100%;
    overflow: hidden;
  }

  table {
    text-align: center;
    font-size: 12px;
    width: 100%;

    thead {
      background: #cae1ff;

      td {
        width: 20%;
      }
    }

    tbody {
      tr {
        background: #fff;

        &:nth-child(2n) {
          background: #e8e8e8;
        }
      }
    }

    td {
      width: 20%;
      padding: 0.1rem;
      box-sizing: border-box;
      word-break: break-all;
    }
  }
}
</style> 